export function buildEndpoint(path: string) {
  return `${process.env.ZENDESK_HELPCENTER_URL}${path}`;
}

export const DUMMY_URL_SCHEME = 'https://depop.com';
export const HELP_BASE_PATH = '/help/';
export const ZENDESK_SSO_PATH = '/zendesk/sso/';
export const ZENDESK_HOME_URL = buildEndpoint('/hc/en-gb/');
export const ZENDESK_JWT_URL = buildEndpoint('/access/jwt');
export const COOKIE_ZENDESK_SSO_STATE = 'zendesk_sso_state';
export const FIVE_MINUTE_EXPIRY = 300;
export const COOKIE_ZENDESK_SSO_STATE_OPTIONS = {
  path: '/',
  maxAge: FIVE_MINUTE_EXPIRY,
  secure: true,
};

export const JWT_PARAM = 'jwt';
export const ZD_SSO_PARAM = 'zd_sso';
export const LOGIN_PARAM = 'login';
export const LOGOUT_PARAM = 'logout';
export const KIND_PARAM = 'kind';
export const KIND_VALUE_ERROR = 'error';
export const RETURN_TO_PARAM = 'return_to';

export const ZENDESK_ALLOWED_QUERY_PARAM_PREFIXES = [
  'tf',
  'ticket_form_id',
] as const;
